import Feed from '../components/Feed';

const home = {
  init() {
    new Feed({
      container: '.js-card-container',
      mobileContainer: '.js-card-mobile-container',
      page: '.js-card-page',
      flipRight: '.js-flip-right',
      flipLeft: '.js-flip-left',
    });
  },
};

export default home.init();



// WEBPACK FOOTER //
// ./pages/home.js